import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  getPayPalStoreAccount,
  PayPalStoreAccountInfo,
} from 'api/admin/stores/getPayPalStoreAccount';

export const usePayPalStoreAccount = (storeId: number) => {
  const {
    isLoading,
    error,
    data = null,
    refetch,
  } = useQuery<unknown, AxiosError<{ error: string }>, PayPalStoreAccountInfo | null>({
    queryKey: ['getPayPalStoreAccount', storeId],
    queryFn: async () => {
      const response = await getPayPalStoreAccount(storeId);
      return response.data?.account ?? null;
    },
    enabled: !!storeId,
    retry: 1,
    onError: (error) => {
      Sentry.captureException(error);

      toaster(error?.response?.data?.error ?? 'An error occurred while fetching PayPal account', {
        icon: '❌',
      });
      return error;
    },
  });

  return {
    isLoading,
    error,
    data,
    refetch,
  };
};
